var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M579 342L579 370",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 579.5,
    cy: 337.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M574.987 337.19C574.987 333.283 578.288 330.117 582.358 330.117C582.943 330.117 583.511 330.184 584.056 330.308C582.742 329.48 581.187 329 579.519 329C574.814 329 571 332.806 571 337.5C571 342.194 574.814 346 579.519 346C581.814 346 583.895 345.093 585.427 343.62C584.492 344.032 583.454 344.263 582.358 344.263C578.288 344.263 574.987 341.096 574.987 337.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M588.402 336.6L588.37 334.146L586.535 335.719L584.304 335.056L585.112 337.337L583.765 339.381L586.1 339.218L587.499 341.144L588.133 338.763L590.345 337.909L588.402 336.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.f805c16d05c2b7f43c45a4efafac9174.svg";
export { ForwardRef as ReactComponent };